 const getStandardEnglishNumber = function (number) {
    //remove space from phone number
    var StandardNumber = number.replace(/\s+/g, '');
    StandardNumber = StandardNumber.replace('+' , '00');
    //change to english number
    //todo use regix
    const persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g]
    const arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g]
    for (var i = 0; i < 10; i++) {
        StandardNumber = StandardNumber.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
    }
    return StandardNumber
}

let getStandardFarsiAlphabet = function(text) {
    var arabic = ['ي', 'ك', 'ة'];
    var farsi = ['ی', 'ک', 'ه'];
    var output = text;
    for (var i = 0; i < arabic.length; i++) {
      output = output.replace(arabic[i], farsi[i]);
    }
    return output;
}

let getStandardNumber = function(number){
    return number >= 10 ? number : `0${number}`;
}

let sepratorDigits = function(Number){
    Number+= '';
    Number= Number.replace(',', '');
    let x = Number.split('.');
    let y = x[0];
    let z= x.length > 1 ? '.' + x[1] : '';
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(y))
        y= y.replace(rgx, '$1' + ',' + '$2');
    return y+ z;
}

module.exports = {
    getStandardEnglishNumber,
    getStandardFarsiAlphabet,
    getStandardNumber,
    sepratorDigits
}